import type { Ben } from "./api";

// Kullanıcı başına saklanır. Çıkış başka kullanıcıya taşımaz; aynı hesabın
// bilinen kilidi ise yalnızca yeni bir sunucu kararıyla kalkar.
export class OnayBilgisi {
  private bellek = new Map<string, boolean>();
  /** Son TAZE `ben` görünüm modunda mıydı — görünümde 403 hedefin anahtarına kilit yazmaz. */
  private gorunumde = false;
  private anahtar(userId: string) {
    return "ogrenci-onay-kilidi:" + userId;
  }

  kilitli(userId: string | null | undefined): boolean {
    if (!userId) return false;
    if (this.bellek.has(userId)) return this.bellek.get(userId) === true;
    try {
      const kayit = localStorage.getItem(this.anahtar(userId));
      if (kayit !== null) return kayit === "evet";
    } catch {
      /* Saklama kapalıysa açık sekme belleği korunur. */
    }
    return this.bellek.get(userId) === true;
  }

  kilitle(userId: string | null): void {
    if (userId && !this.gorunumde) this.yaz(userId, true);
  }

  private yaz(userId: string, kilitli: boolean) {
    this.bellek.set(userId, kilitli);
    try {
      localStorage.setItem(this.anahtar(userId), kilitli ? "evet" : "hayir");
    } catch {
      /* Bellekteki karar geçerlidir. */
    }
  }

  benYanitiniIsle(ben: Ben, agdan: boolean): Ben {
    if (!ben.girisYapildi || !ben.userId) return ben;
    // GÖRÜNÜM (Codex tur 32 [P2]): `ben.userId` görünüm HEDEFİ, `ben.onayKilidi` GERÇEK kişinin. İkisini tek anahtarda
    // birleştirmek hedefin kaydını yanlış kilitliyor ya da temizliyordu. Görünümde hiçbir şey saklanmaz, silinmez;
    // kilit ekranı sunucunun o anki kararından çizilir (görünüm çevrimiçi bir yönetim akışı).
    if (agdan) this.gorunumde = ben.gorunumde === true;
    if (ben.gorunumde === true) return ben;
    if (agdan) {
      // Ağdan gelen yanıtta alan HİÇ yoksa sunucu kilit uygulamıyor (eski API: istemci önce dağıtıldığında ya da
      // geri dönüşte). Temizlenmezse bir kez kilit görmüş kullanıcı kaçışsız kilitte kalırdı (Claude, tur 31 incelemesi).
      if (
        ben.onayKilidi === undefined ||
        ben.onayKilidiDevreDisi === true ||
        ben.onayKilidi?.kilitli === false
      )
        this.yaz(ben.userId, false);
      else if (ben.onayKilidi?.kilitli === true) this.kilitle(ben.userId);
    }
    if (!this.kilitli(ben.userId)) return ben;
    return {
      ...ben,
      onayKilidiDevreDisi: false,
      onayKilidi: {
        kimVerir: ben.onayKilidi?.kimVerir ?? "KENDISI",
        eksikler: ben.onayKilidi?.eksikler ?? [],
        kilitli: true,
      },
    };
  }
}

export const onayBilgisi = new OnayBilgisi();
